
import { useCallback } from "react";
import { Button } from "@/components/ui/button";
import { Minus, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmergencyRestTimeControlsProps {
  exerciseRestTime: number | null | undefined;
  setRestTime: number | null | undefined;
  onRestTimeChange: (field: "exercise_rest_time" | "set_rest_time", value: number) => void;
  isPersonalPlan?: boolean;
}

export const EmergencyRestTimeControls = ({
  exerciseRestTime,
  setRestTime,
  onRestTimeChange,
  isPersonalPlan = false
}: EmergencyRestTimeControlsProps) => {
  
  const handleExerciseRestChange = useCallback((increment: boolean) => {
    const currentValue = exerciseRestTime || 0;
    const newValue = increment ? currentValue + 15 : Math.max(0, currentValue - 15);
    onRestTimeChange("exercise_rest_time", newValue);
  }, [exerciseRestTime, onRestTimeChange]);

  const handleSetRestChange = useCallback((increment: boolean) => {
    const currentValue = setRestTime || 0;
    const newValue = increment ? currentValue + 15 : Math.max(0, currentValue - 15);
    onRestTimeChange("set_rest_time", newValue);
  }, [setRestTime, onRestTimeChange]);

  if (!isPersonalPlan) {
    return null;
  }

  return (
    <div className="space-y-4">
      {/* Exercise Rest Time */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-black dark:text-white forest:text-white sunset:text-[#ef5609]">
          Descanso entre ejercicios
        </label>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleExerciseRestChange(false)}
            className={cn(
              "h-8 w-8 p-0 border-[#2196A3]/50 hover:border-[#00C1D6] hover:bg-[#00C1D6]/20",
              "dark:border-white/20 dark:hover:border-[#00C1D6]"
            )}
          >
            <Minus className="h-4 w-4" />
          </Button>
          <span className="min-w-[4rem] text-center font-medium text-black dark:text-white forest:text-white sunset:text-[#ef5609]">
            {exerciseRestTime || 0}s
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleExerciseRestChange(true)}
            className={cn(
              "h-8 w-8 p-0 border-[#2196A3]/50 hover:border-[#00C1D6] hover:bg-[#00C1D6]/20",
              "dark:border-white/20 dark:hover:border-[#00C1D6]"
            )}
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {/* Set Rest Time */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-black dark:text-white forest:text-white sunset:text-[#ef5609]">
          Descanso entre series
        </label>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleSetRestChange(false)}
            className={cn(
              "h-8 w-8 p-0 border-[#2196A3]/50 hover:border-[#00C1D6] hover:bg-[#00C1D6]/20",
              "dark:border-white/20 dark:hover:border-[#00C1D6]"
            )}
          >
            <Minus className="h-4 w-4" />
          </Button>
          <span className="min-w-[4rem] text-center font-medium text-black dark:text-white forest:text-white sunset:text-[#ef5609]">
            {setRestTime || 0}s
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleSetRestChange(true)}
            className={cn(
              "h-8 w-8 p-0 border-[#2196A3]/50 hover:border-[#00C1D6] hover:bg-[#00C1D6]/20",
              "dark:border-white/20 dark:hover:border-[#00C1D6]"
            )}
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
